module.exports = __webpack_public_path__ + "img/hr-concrete-hole-decal-15.8ad2c930.png";